import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fill-height d-flex flex-column" }
const _hoisted_2 = { class: "d-flex mb-4" }
const _hoisted_3 = { class: "d-flex flex-grow-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_download_button_with_pop_up = _resolveComponent("download-button-with-pop-up")!
  const _component_parameter_card = _resolveComponent("parameter-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_spacer),
      _createVNode(_component_download_button_with_pop_up, {
        title: _ctx.t('download_form.parameter_metadata'),
        testid: 'raster-parameter-metadata',
        outlined: "",
        "format-choices": [{ title: 'CSV', value: 'csv' }],
        "file-suffix": ' ' + _ctx.t('download_form.parameter_metadata'),
        onDownload: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadParameterMetadata($event)))
      }, null, 8, ["title", "file-suffix"]),
      _createVNode(_component_download_button_with_pop_up, {
        title: _ctx.t('download_form.dataset'),
        testid: 'raster-data',
        "format-choices": _ctx.getOutputFormatOptions,
        "file-suffix": ' ' + _ctx.t('download_form.dataset'),
        "show-date-picker": true,
        "date-picker-text-field-props": {
          'error-messages': _ctx.dateRangeTextFieldErrorMsg,
        },
        "disable-download-button": !!_ctx.dateRangeTextFieldErrorMsg,
        disabled: _ctx.parameterStore.selectedParameters.length === 0,
        onDownload: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadDataset($event)))
      }, null, 8, ["title", "format-choices", "file-suffix", "date-picker-text-field-props", "disable-download-button", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_parameter_card, {
        class: "card ml-2",
        title: _ctx.parameterCardTitle,
        items: _ctx.parameterStore.allParameters,
        selected: _ctx.parameterStore.selectedParameters,
        onSelectedChanged: _cache[2] || (_cache[2] = ($event: any) => (_ctx.parameterStore.updateSelectedParameters($event)))
      }, null, 8, ["title", "items", "selected"])
    ])
  ]))
}